"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYearsPickerRangeStart = exports.getYear = exports.getMonth = exports.getMinute = exports.getHour = exports.getFormattedLongDateTime = exports.getFormattedDate = exports.getDate = exports.allMonths = exports.allMins = exports.allHours = void 0;
Object.defineProperty(exports, "setDate", {
  enumerable: true,
  get: function () {
    return _setDate["default"];
  }
});
Object.defineProperty(exports, "setHours", {
  enumerable: true,
  get: function () {
    return _setHours["default"];
  }
});
Object.defineProperty(exports, "setMinutes", {
  enumerable: true,
  get: function () {
    return _setMinutes["default"];
  }
});
Object.defineProperty(exports, "setMonth", {
  enumerable: true,
  get: function () {
    return _setMonth["default"];
  }
});
exports.setTime = void 0;
Object.defineProperty(exports, "setYear", {
  enumerable: true,
  get: function () {
    return _setYear["default"];
  }
});
var _dateFns = require("date-fns");
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _getHours = _interopRequireDefault(require("date-fns/getHours"));
var _getMinutes = _interopRequireDefault(require("date-fns/getMinutes"));
var _setDate = _interopRequireDefault(require("date-fns/setDate"));
var _setMonth = _interopRequireDefault(require("date-fns/setMonth"));
var _setYear = _interopRequireDefault(require("date-fns/setYear"));
var _setHours = _interopRequireDefault(require("date-fns/setHours"));
var _setMinutes = _interopRequireDefault(require("date-fns/setMinutes"));
const allMonths = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'short';
  let local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  return Array.from({
    length: 12
  }, (_, i) => new Date(0, i).toLocaleString(local, {
    month: type
  }));
};
exports.allMonths = allMonths;
const allHours = () => {
  const hours = [];
  for (let i = 0; i <= 23; i++) {
    if (i < 10) {
      hours.push("0".concat(i));
    } else {
      hours.push("".concat(i));
    }
  }
  return hours;
};
exports.allHours = allHours;
const allMins = () => {
  const mins = [];
  for (let i = 0; i <= 59; i++) {
    if (i < 10) {
      mins.push("0".concat(i));
    } else {
      mins.push("".concat(i));
    }
  }
  return mins;
};
exports.allMins = allMins;
const getDate = value => (0, _dateFns.format)(new Date(value), 'dd');
exports.getDate = getDate;
const getYear = value => (0, _dateFns.format)(new Date(value), 'yyyy');
exports.getYear = getYear;
const getMonth = value => {
  const month = +(0, _dateFns.format)(new Date(value), 'M');
  return month - 1;
};
exports.getMonth = getMonth;
const setTime = (startDate, hour, min) => {
  let updateDate;
  if (hour !== null) {
    updateDate = (0, _setHours["default"])(startDate, hour);
  }
  if (min !== null) {
    updateDate = (0, _setMinutes["default"])(startDate, min);
  }
  return updateDate || new Date(new Date().setHours(0, 0, 0));
};
exports.setTime = setTime;
const getHour = date => (0, _getHours["default"])(date);
exports.getHour = getHour;
const getMinute = date => (0, _getMinutes["default"])(date);
exports.getMinute = getMinute;
const getYearsPickerRangeStart = dateYear => {
  let rangeStart = Number(dateYear);
  let count = 0;
  while (!Number.isInteger((dateYear - count) / 12)) {
    count++;
  }
  rangeStart = dateYear - count + 1;
  return [rangeStart, ' ~ ', rangeStart + 11];
};
exports.getYearsPickerRangeStart = getYearsPickerRangeStart;
const getFormattedDate = function (value) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dd/MM/yyyy';
  return (0, _parse["default"])(value, format, new Date());
};
exports.getFormattedDate = getFormattedDate;
const getFormattedLongDateTime = function (value) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dd/MM/yyyy HH:mm';
  return (0, _parse["default"])(value, format, new Date());
};
exports.getFormattedLongDateTime = getFormattedLongDateTime;